import { Middleware } from "../middleware"
export default {
    //GRAPH AND LIST  
    getIndicatorsLoki (filter) {
        return new Middleware()
            .method('GET')
            .append('/loki/indicators')
            .params({
                idCompany: filter.idCompany
            })
            .build()
    },
    getStatusLokiMonitoring () {
        return new Middleware()
            .method('GET')
            .append('/loki/status-list/monitoring')
            .build()
    },
    getCounterLoki (filter) {
        return new Middleware()
        
            .method('GET')
            .append('/loki/donut-chart')
            .params({
                idCompany: filter.idCompany,
                startDate: filter.startDate,
                endDate: filter.endDate
            })
            .build()
    },

    //STRING
    getStringLoki (filter) {
        return new Middleware()
            .method('GET')
            .append('/loki/string-monitoring/all')
            .params({
                search: filter.search,
                page: filter.page,
                size: filter.size,
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany,
            })
            .build()
    },
    setStringLoki (payload) {
        return new Middleware()
            .method('POST')
            .append('/loki/string-monitoring/add')
            .setData(payload)
            .build()
    },
    updateStringLoki (payload, id) {
        return new Middleware()
            .method('PUT')
            .append(`/loki/string-monitoring/${id}`)
            .setData(payload)
            .build()
    },
    removeStringLoki (data) {
        return new Middleware()
            .method('DELETE')
            .append(`/loki/string-monitoring/${data.id}`)
            .params({
                idCompany: data.clientid
            })
            .build()
    },


    //DOMAIN
    getDomainLoki (filter) {
        return new Middleware()
            .method('GET')
            .append('/loki/domain-monitoring/all')
            .params({
                search: filter.search,
                page: filter.page,
                size: filter.size,
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany,
            })
            .build()
    },
    setDomainLoki (payload) {
        return new Middleware()
            .method('POST')
            .append('/loki/domain-monitoring/add')
            .setData(payload)
            .build()
    },
    updateDomainLoki (payload, id) {
        return new Middleware()
            .method('PUT')
            .append(`/loki/domain-monitoring/${id}`)
            .setData(payload)
            .build()
    },
    removeDomainLoki (data) {
        return new Middleware()
            .method('DELETE')
            .append(`/loki/domain-monitoring/${data.id}`)
            .params({
                idCompany: data.clientid
            })
            .build()
    },

   //CHANNEL
    getChannelsLoki (filter) {
        return new Middleware()
            .method('GET')
            .append('/loki/commschannels-findings/summarized')
            .params({
                search: filter.search,
                page: filter.page,
                size: filter.size,
                startDate: filter.startDate,
                endDate: filter.endDate,
                idCompany: filter.idCompany,
            })
            .build()
    },

    //LEAK
    getLeakLoki(filter){
        return new Middleware()
        .method('GET')
        .append('/loki/leaks-findings/summarized')
        .params({
            search: filter.search,
            page: filter.page,
            size: filter.size,
            startDate: filter.startDate,
            endDate: filter.endDate,
            idCompany: filter.idCompany,
        })
        .build()
    },

    //VIP
    getVipLoki( filter){
        return new Middleware()
        .method('GET')
        .append('/loki/vips/all')
        .params({
            search: filter.search,
            page: filter.page,
            size: filter.size,
            startDate: filter.startDate,
            endDate: filter.endDate,
            idCompany: filter.idCompany,
        })
        .build()
    },
    setVipLoki (payload) {
        return new Middleware()
            .method('POST')
            .append('/loki/vips/add')
            .setData(payload)
            .build()
    },
    updateVipLoki (payload, id) {
        return new Middleware()
            .method('PUT')
            .append(`/loki/vips/${id}`)
            .setData(payload)
            .build()
    },
    removeVipLoki (data) {
        return new Middleware()
            .method('DELETE')
            .append(`/loki/vips/${data.id}`)
            .params({
                idCompany: data.company['idCompany']
            })
            .build()
    },



}